export default ({ createSubdeployment, history, deploymentId, onSuccess }) => values => {
  const updatedData = createSubdeployment({
    variables: {
      subdeploymentInput: values,
      history,
      deploymentId
    },
  });

  return updatedData.then(result => {
    const subdeployment = result?.data?.createSubdeployment;
    if (subdeployment && subdeployment.id) {
      onSuccess();
    }
  });
};
